<template>
  <van-popup v-model="dialogVisible" round position="bottom">
    <div class="voucher-desc">
      <div class="voucher-title">
        <div class="back" @click="dialogVisible = false">
          <img src="@/assets/images/ic_arrow_one.png" alt="" />
          <span>返回</span>
        </div>
        <h1>代金券说明</h1>
        <img
          class="swiper-close"
          src="@/assets/images/close-voucher.png"
          alt=""
          @click="dialogVisible = false"
        />
      </div>

      <div class="coupon_desc_table">
        <div class="table_thead">
          <div class="thead_platform color-FF7A3E">平台</div>
          <div class="thead_exp">
            <div class="exp_head color-FF7A3E">代金券有效期</div>
            <div class="exp_type">
              <span class="color-FF7A3E">首充</span>
              <span class="color-FF7A3E">续充</span>
            </div>
          </div>
        </div>

        <div class="table_tbody">
          <div class="table_tbody_th">
            <div class="tbody_th_td">果盘</div>
            <div class="tbody_th_td_span">
              <span class="color-FF7A3E"> 30天 </span>
              <span> 30天 </span>
            </div>
          </div>
          <div class="table_tbody_th">
            <div class="tbody_th_td">3011</div>
            <div class="tbody_th_td_span">
              <span> 90天 </span>
              <span> 90天 </span>
            </div>
          </div>
          <div class="table_tbody_th">
            <div class="tbody_th_td fs-22 line-height-common">天宇、爱趣、91玩、
              当乐、98sy</div>
            <div class="tbody_th_td_span">
              <span> 长期 </span>
              <span> 长期 </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    //定义这个swiper对象
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  data() {
    return {};
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.voucher-desc {
  padding: 30px;

  .voucher-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;

    .back {
      display: flex;
      align-items: center;
      position: absolute;
      left: 30px;
      top: 32px;
      img {
        width: 16px;
        height: 28px;
        margin-right: 6px;
      }
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 28px;
        color: #ff7a3e;
        line-height: 40px;
      }
    }
    h1 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #000000;
      line-height: 45px;
    }
  }
  .coupon_desc_table {
    border-radius: 8px;
    border: 1px solid #e6e6e6;

    .table_thead {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e6e6e6;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #7b7b7b;

      .thead_platform {
        height: 120px;
        line-height: 120px;
        width: 300px;
        text-align: center;
        border-right: 1px solid #e6e6e6;
      }
      .thead_exp {
        .exp_head {
          width: 388px;
          text-align: center;
          height: 60px;
          line-height: 60px;
          border-bottom: 1px solid #e6e6e6;
        }
        .exp_type {
          display: flex;
          align-items: center;
          span {
            width: 194px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            &:last-child {
              border-left: 1px solid #e6e6e6;
            }
          }
        }
      }
    }
    .table_tbody {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #7b7b7b;
      box-sizing: border-box;
      .table_tbody_th {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e6e6e6;
        .tbody_th_td {
          width: 300px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          border-right: 1px solid #e6e6e6;
        }
        .line-height-common {
          line-height: 30px;
        }
        .fs-22 {
          font-size: 22px;
        }
        .tbody_th_td_span {
          display: flex;
          align-items: center;
          span {
            width: 194px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            &:last-child {
              border-left: 1px solid #e6e6e6;
            }
          }
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
    .color-FF7A3E {
        color: #ff7a3e;
        font-weight: 600;
    }
  }
  .swiper-close {
    width: 38px;
    height: 38px;
    position: absolute;
    right: 30px;
    top: 38px;
    z-index: 999;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VoucherDescDialog.vue